let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aQC4s")).then(() => parcelRequire('9Uve2'));